export enum Civility {
  MALE = 'MALE',

  FEMALE = 'FEMALE',
}
